"use client";

import { ReactNode, useState } from "react";

export function Question({
  text,
  children,
}: {
  text: string;
  children?: ReactNode | ReactNode[];
}) {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <div className="w-full max-w-[799px] text-[#0f1219]">
      <div
        onClick={() => setOpen((o) => !o)}
        className="flex w-full cursor-pointer items-center justify-between border-b border-[#0f1219]/14 pt-2.5 pr-2.5"
      >
        <div className="w-full max-w-[694px] py-3 text-lg font-medium">
          {text}
        </div>
        <svg
          width="11"
          height="7"
          viewBox="0 0 11 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`transition-transform duration-300 ${
            open ? "rotate-180" : "rotate-0"
          }`}
        >
          <path
            d="M1 1L5.5 5.5L10 1"
            stroke="#FF5B92"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div
        className={`overflow-hidden transition-all duration-500 ease-in-out ${
          open ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
        style={{ maxHeight: open ? "500px" : "0" }}
      >
        <div className="w-full max-w-[694px] py-8 text-[0.98rem] leading-7 text-[#2f3345]">
          {children}
        </div>
      </div>
    </div>
  );
}
